import alt from 'components/Dispatcher';
import {browserHistory} from 'react-router';
import API from 'sources/API';

class OpportunityActions {
    setLoading(loading) {
        return loading;
    }
    // 更新 Opportunity 详情
    updateOpportunity(opportunity) {
        return opportunity;
    }
    // 更新 offset
    updateOpportunityOffset(offset) {
        return offset;
    }
    // 获取 Opportunity 详情
    fetchOpportunity(id) {
        return id;
    }
    // 更新 Opportunity registers 详情
    updateOpportunityRegister(registers){
        return registers;
    }
    // 获取 Opportunity register
    fetchOpportunityRegister(id) {
        return id;
    }
    // 更新 Opportunity selecter 详情
    updateOpportunitySelecter(selecters){
        return selecters;
    }
    // 获取 Opportunity selecter
    fetchOpportunitySelecter(id) {
        return id;
    }
    // 追加 OpportunityList
    updateOpportunityList(opportunityList) {
        return opportunityList;
    }
    // 更新全部 OpportunityList
    updateAllOpportunityList(opportunityList) {
        return opportunityList;
    }
    // 获取更多 OpportunityList
    fetchOpportunityList() {
        return true;
    }
    clearOpportunityRegister() {
        return true;
    }
    clearOpportunitySelecter() {
        return true;
    }
    clearOpportunity() {
        return true;
    }
    setRegistersLoading(loading) {
        return loading;
    }
    setSelectersLoading(loading) {
        return loading;
    }
    // 请求成功后统一回调
    fetchSuccess(res) {
        if(res.status === 0) {
            this[res.updateFnName](res.result);
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    // 请求失败后统一回调
    fetchFailed(err) {
        console.log(err);
        if(err.status === 401) {
            if(API.isWechat) {
                location.href = API.redirectWechatLogin;
            } else {
                browserHistory.push('/login');
            }
        }
        return err;
    }
}

export default alt.createActions(OpportunityActions);



// WEBPACK FOOTER //
// ./src/actions/OpportunityActions.js